export const frUsers = {
    // USERS

    'users.list.pageTitle': 'Collaborateurs',
    'users.list.sectionTitle': 'Collaborateurs',
    'users.list.emptyLabel': 'Aucun collaborateur pour le moment.',
    'users.list.actions.addUser': 'Ajouter un collaborateur',
    'users.list.actions.importExcel': 'Import Excel',
    'users.list.actions.exportExcel': 'Export Excel',
    'users.list.othersLabel': 'autres centres',
    'users.list.dialog.title': 'Suppression de ce collaborateur',
    'users.list.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce collaborateur ?',
    'users.list.dialog.validateLabel': 'Supprimer',
    'users.list.dialog.cancelLabel': 'Annuler',
    'users.list.headers.info': 'Informations utilisateur',
    'users.list.headers.email': 'Email',
    'users.list.headers.roles': 'Rôles',
    'users.list.headers.shops': 'Centres',
    'users.list.headers.comments': 'Commentaires',

    // USERS >> CREATE

    'users.create.pageTitle': 'Création collaborateur',
    'users.create.sectionTitle': 'Centres',
    'users.create.createInfo':
        'Pas de centres pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter le collaborateur à des centres.',
    'users.create.actions.cancelCreation': 'Annuler la création',
    'users.create.actions.addTheUser': 'Enregistrer',
    'users.create.input.firstName': 'Saisissez ici le prénom du collaborateur *',
    'users.create.input.floatingLabelFirstName': 'Prénom',
    'users.create.input.lastName': 'Saisissez ici le nom du collaborateur *',
    'users.create.input.floatingLabelLastName': 'Nom',
    'users.create.input.code': 'Saisissez ici le nom du collaborateur',
    'users.create.input.floatingLabelCode': 'Code',
    'users.create.input.email': "Saisissez ici l'email du collaborateur *",
    'users.create.input.floatingLabelEmail': 'Adresse email',
    'users.create.input.comment': 'Saisissez ici votre commentaire',
    'users.create.input.floatingLabelComment': 'Commentaire',

    // USERS >> DETAILS

    'users.details.pageTitle': 'Détails collaborateur',
    'users.details.generalInfoTitle': 'INFORMATIONS GÉNÉRALES',
    'users.details.sectionTitle': 'Liste centres',
    'users.details.centersTitle': 'LISTE CENTRES',
    'users.details.detailsInfo':
        'Pas de centres pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Centres » où vous pourrez affecter le collaborateur à des centres.',
    'users.details.actions.save': 'Enregistrer',
    'users.details.actions.removeUser': 'Supprimer le collaborateur',
    'users.details.actions.disabledRemoveInfo':
        'Ce collaborateur possède des centres et ne peut être supprimé.',
    'users.details.actions.previous': 'Collaborateurs',
    'users.details.dialog.title': 'Suppression de ce collaborateur',
    'users.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce collaborateur ?',
    'users.details.dialog.validateLabel': 'Supprimer',
    'users.details.dialog.cancelLabel': 'Annuler',
    'users.details.input.firstName': 'Saisissez ici le prénom du collaborateur *',
    'users.details.input.floatingLabelFirstName': 'Prénom',
    'users.details.input.lastName': 'Saisissez ici le nom du collaborateur *',
    'users.details.input.floatingLabelLastName': 'Nom',
    'users.details.input.code': 'Saisissez ici le nom du collaborateur',
    'users.details.input.floatingLabelCode': 'Code',
    'users.details.input.email': "Saisissez ici l'email du collaborateur *",
    'users.details.input.floatingLabelEmail': 'Adresse email',
    'users.details.input.comment': 'Saisissez ici votre commentaire',
    'users.details.input.floatingLabelComment': 'Commentaire',
    // PINCODES TO TRAD
    'users.details.input.pincodes': 'Date de validation du code pin',
    'users.details.input.pincodes.state.PinInProgress': 'En attente',
    'users.details.input.pincodes.state.PinValidated': 'Actif',
    'users.details.input.pincodes.state.Locked': 'Inactif',
    'users.details.input.pincodes.undefined': 'N/C',

    //TOAST
    'users.import.success': 'Bravo! Utilisateur importés avec succès',

    // USER > RESET PWD

    'user.any.details.button.reset.password.demand.label': 'Réinitialiser le mot de passe',
    'user.any.details.button.reset.password.dialog.title': 'Réinitialisation du mot de passe',
    'user.any.details.button.reset.password.dialog.content':
        'Voulez-vous vraiment réinitialiser le mot de passe ?',

    'user.any.details.button.reset.password.dialog.confirm.label': 'Envoyer la demande',
    'user.any.details.password.reset.success': 'Email de réinitialisation envoyé',

    // USER > INVITE

    'user.any.details.button.invite.password.demand.label': "Envoyer un email d'invitation",
    'user.any.details.button.generate.password.demand.label':
        "Envoyer un mail d'invitation avec MDP",
    'user.any.details.button.invite.password.dialog.title': "Envoyer un email d'invitation",
    'user.any.details.button.invite.password.dialog.content':
        "Voulez-vous vraiment envoyer un email d'invitation ?",
    'user.any.details.button.invite.password.dialog.confirm.label': "Envoyer l'invitation",
    'user.any.details.invite.success': "Email d'invitation envoyée",
};
